module.exports = "hello from contact component"


//////////////////
// WEBPACK FOOTER
// ./src/app/route/public/contact/contact.component.pug
// module id = 1084
// module chunks = 1